// extracted by mini-css-extract-plugin
export var addToCartButton = "_j9-b";
export var arrowButtonContainer = "_j9-9";
export var arrowButtonIcon = "_j9-a";
export var carouselArrowButton = "_j9-6";
export var carouselElementContainer = "_j9-1";
export var left = "_j9-7";
export var productDisplayCarouselContainer = "_j9-0";
export var productTileContainer = "_j9-2";
export var productTileImage = "_j9-4";
export var productTileImageContainer = "_j9-3";
export var productTileTitle = "_j9-5";
export var right = "_j9-8";
export var sliderOverflow = "_j9-c";